/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heroic_Safe_Cheetah_TickleInputs */

const fr_heroic_safe_cheetah_tickle = /** @type {(inputs: Heroic_Safe_Cheetah_TickleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrer par`)
};

/**

* @param {Heroic_Safe_Cheetah_TickleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const heroic_safe_cheetah_tickle = /** @type {((inputs?: Heroic_Safe_Cheetah_TickleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heroic_Safe_Cheetah_TickleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_heroic_safe_cheetah_tickle(inputs)
});